export default "__VITE_ASSET__CxMSrvIV__"